module.exports = __webpack_public_path__ + "img/petstairs11.8fe70d13.jpg";